import {getDiagnosisSelectionVersion} from '@/features/projects/diagnosisVersion'
import {useGetDiagnoses} from '@/features/projects/queries/useGetDiagnoses'
import {DiagnosisVersionFilter} from '@/features/projects/types'
import {useInputSearch} from '@/hooks/useInputSearch'

interface UsePathologiesSearchableListProps {
    limit?: number
    enabled?: boolean
    /** Defaults to the classification currently in force (ICD9, or ICD10 from ICD10_MANDATORY_FROM). */
    version?: DiagnosisVersionFilter
}

export const usePathologiesSearchableList = ({limit = 10, enabled, version}: UsePathologiesSearchableListProps) => {
    const searchControls = useInputSearch()
    const query = useGetDiagnoses({
        params: {
            page: 1,
            limit,
            search: searchControls.searchValue,
            version: version ?? getDiagnosisSelectionVersion()
        },
        options: {enabled}
    })

    return {
        ...query,
        ...searchControls,
        pathologies: query.data?.pages.flatMap(page => page.data) ?? []
    }
}
